export let PAGINATION_FIRST = 20;

export let TYPES_ICONS = {
  'case': { icon: 'account_circle', color: 'orange'},
  'sample': { icon: 'fingerprint', color: 'forestgreen'},
  'portion': { icon: 'fingerprint', color: 'forestgreen'},
  'slide': { icon: 'fingerprint', color: 'forestgreen'},
  'analyte': { icon: 'fingerprint', color: 'forestgreen'},
  'aliquot': { icon: 'fingerprint', color: 'forestgreen'},
  'read_group': { icon: 'fingerprint', color: 'forestgreen'},
};

export let BIOSPECIMEN_ORDER = [
  'sample',
  'portion',
  'slide',
  'analyte',
  'aliquot',
  'read_group',
];

export let SUBMITTABLE_DATA_FILES_ORDER = [
  'submitted_unaligned_reads',
  'submitted_aligned_reads',
  'slide_image',
  'pathology_report',
  'clinical_supplement',
  'biospecimen_supplement',
  'submitted_tangent_copy_number',
  'analysis_metadata',
  'run_metadata',
  'experiment_metadata',
];

export const HARMONIZED_DATA_FILES = [
  'aggregated_somatic_mutation',
  'aligned_reads',
  'annotated_somatic_mutation',
  'gene_expression',
  'mirna_expression',
  'simple_somatic_mutation',
];

export const SUBMITTABLE_EXPERIMENTAL_STRATEGIES = {
  rna: "RNA-Seq",
  wgs: "WGS",
  wxs: "WXS",
  low_pass_wgs: "Low Pass WGS",
  mi_rna_seq: "miRNA-Seq",
  targeted_seq: "Targeted Sequencing",
  bisulfite_seq: "Bisulfite-Seq",
  chip_seq: "ChIP-Seq",
  atac_seq: "ATAC-Seq"
}
